var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.153,
    height: 20.153,
    viewBox: "0 0 20.153 20.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17150",
    "data-name": "Group 17150",
    transform: "translate(0.002 0.044)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 20.153,
    height: 20.153,
    transform: "translate(-0.002 -0.044)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user(1)",
    transform: "translate(2.998 1.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15807",
    "data-name": "Group 15807",
    transform: "translate(3.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15806",
    "data-name": "Group 15806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8010",
    "data-name": "Path 8010",
    d: "M125.515,0a4.515,4.515,0,1,0,4.515,4.515A4.52,4.52,0,0,0,125.515,0Z",
    transform: "translate(-121 0)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15809",
    "data-name": "Group 15809",
    transform: "translate(0 10.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15808",
    "data-name": "Group 15808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8011",
    "data-name": "Path 8011",
    d: "M44.142,301.946A6.436,6.436,0,0,0,39.528,300H37.521a6.437,6.437,0,0,0-4.614,1.946A6.58,6.58,0,0,0,31,306.588a.5.5,0,0,0,.5.5H45.548a.5.5,0,0,0,.5-.5A6.58,6.58,0,0,0,44.142,301.946Z",
    transform: "translate(-31 -300)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullName);
export default __webpack_public_path__ + "static/media/full_name.6d6c53df1d5a08a80ff46e78d9436f97.svg";
export { ForwardRef as ReactComponent };